import type { FC } from 'react';

import { ConfirmDialog } from '@revelio/ui';

interface UnsavedChangesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isNewPage?: boolean;
}

export const UnsavedChangesDialog: FC<UnsavedChangesModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isNewPage = false,
}) => (
  <ConfirmDialog
    open={isOpen}
    title={isNewPage ? 'Exit without creating?' : 'Discard changes?'}
    cancelLabel="Back"
    confirmLabel={isNewPage ? 'Cancel & Exit' : 'Discard & Exit'}
    destructive
    onConfirm={onConfirm}
    onCancel={onClose}
  >
    {isNewPage
      ? 'Your new dashboard has not been created yet. Are you sure you want to exit?'
      : 'You have unsaved changes. They will be lost if you discard and exit.'}
  </ConfirmDialog>
);
